
define('ldsh!modules/editor/templates/elements/image', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-item-image-helper">\n  <span class="js-icon ed-icon ed-icon-image"></span>\n  <!-- <p class="lead-text">Imagen no configurada</p> -->\n  <p><a href="#" data-bypass class="js-edit" data-i18n="editor.image.emptyImageEditButton"></a></p>\n\n  <!-- spinner -->\n  <div class="ed-item-inner-spinner js-spinner">\n    <div class="ed-loading"> <i class="ed-icon ed-icon-refresh" aria-hidden="true"></i></div>\n  </div>\n</div>\n';

}
return __p
};});

